import { defineMessages } from 'react-intl';

const enumMessages = defineMessages({
    LOCATIONSDETAILSFORMTYPE: {
        id: 'LocationsDetailsForm.type',
        defaultMessage: 'Type is a required field',
    },
    LOCATIONSDETAILSFORMADDERSS: {
        id: 'LocationsDetailsForm.adderss',
        defaultMessage: 'Address Line 1 is a required field',
    },
    LOCATIONSDETAILSFORMCITY: {
        id: 'LocationsDetailsForm.city',
        defaultMessage: 'City is a required field',
    },
    LOCATIONSDETAILSFORMNEIGHBORHOOD: {
        id: 'LocationsDetailsForm.neighborhood',
        defaultMessage: 'Province/County is a required field',
    },
    LOCATIONSDETAILSFORMZIP_CODEREQUIRED: {
        id: 'LocationsDetailsForm.zip_codeRequired',
        defaultMessage: 'Zip/Postal code is a required field',
    },
    LOCATIONSDETAILSFORMZIP_CODELENGTH: {
        id: 'LocationsDetailsForm.zip_codeLength',
        defaultMessage: 'Zip/Postal code must have between 1 and 9 chars.',
    },
    LOCATIONSDETAILSFORMCOUNTRY: {
        id: 'LocationsDetailsForm.country',
        defaultMessage: 'Country is a required field',
    },
});

export default enumMessages;
